export const SupportedVariants = {
  youtube: 'youtube',
};
export const DefaultVariant = SupportedVariants.youtube;
